// extracted by mini-css-extract-plugin
export default {"root":"info_root__3aFOp","list":"info_list__ROW1w","listItem":"info_listItem__RG93H","line":"info_line__YrtPn","underlined":"info_underlined__G9nmx"};